import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useWizardProgress, WIZARD_STEPS } from './useWizardProgress';

export function RequireWizard() {
  const { completedSteps, isDismissed, isCompleted, isLoading } = useWizardProgress();
  const location = useLocation();

  if (isLoading) return null;

  // Treat a completed onboarding as satisfying the gate too — existing tenants who finished
  // the pre-wizard onboarding have isCompleted=true but no per-step wizardSteps, and must not
  // be trapped at /setup.
  const allStepsDone = completedSteps.length >= WIZARD_STEPS.length || isCompleted;

  if (!allStepsDone && !isDismissed && location.pathname !== '/setup') {
    return <Navigate to="/setup" replace />;
  }

  return <Outlet />;
}
